<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Add New User</h2>
        <button class="close-button" @click="closeModal">&times;</button>
      </div>

      <form @submit.prevent="submitForm" class="modal-form">
        <!-- Full Name Field -->
        <div class="form-group">
          <label for="fullName" class="form-label">Full Name</label>
          <input
            id="fullName"
            v-model="formData.fullName"
            type="text"
            placeholder="John Doe"
            class="form-input"
            required
          />
        </div>

        <!-- Email Field -->
        <div class="form-group">
          <label for="email" class="form-label">Email</label>
          <input
            id="email"
            v-model="formData.email"
            type="email"
            placeholder="john@company.com"
            class="form-input"
            required
          />
        </div>

        <!-- Phone Number Field -->
        <div class="form-group">
          <label for="phone" class="form-label">Phone Number</label>
          <input
            id="phone"
            v-model="formData.phone"
            type="tel"
            placeholder="e.g., +1 (555) 123-4567"
            class="form-input"
          />
        </div>

        <!-- Password Field -->
        <div class="form-group">
          <label for="password" class="form-label">Password</label>
          <input
            id="password"
            v-model="formData.password"
            type="password"
            placeholder="••••••••"
            class="form-input"
            required
          />
        </div>

        <!-- Owner Checkbox -->
        <!-- <div class="checkbox-group">
          <input
            id="isOwner"
            v-model="formData.isOwner"
            type="checkbox"
            class="checkbox-input"
          />
          <label for="isOwner" class="checkbox-label">
            <span class="crown-icon">👑</span>
            Make this user an Owner
          </label>
        </div> -->

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button type="button" class="cancel-button" @click="closeModal">
            Cancel
          </button>
           <button type="submit" class="create-button" :disabled="loading">
              <span v-if="loading">Creating...</span>
              <span v-else>Create User</span>
        </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddUserModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      formData: {
        fullName: '',
        email: '',
        phone: '',
        password: '',
        isOwner: false
      }
    }
  },
  methods: {
    closeModal() {
      this.resetForm()
      this.$emit('close')
    },
    submitForm() {
      if (!this.formData.fullName || !this.formData.email || !this.formData.password) {
        alert('Please fill in all required fields')
        return
      }

      // Emit the form data to parent component
      this.$emit('create', {
        fullName: this.formData.fullName,
        email: this.formData.email,
        phone: this.formData.phone,
        password: this.formData.password,
        role: 'User'
      })

      this.resetForm()
    },
    resetForm() {
      this.formData = {
        fullName: '',
        email: '',
        phone: '',
        password: '',
        isOwner: false
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 520px;
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  transition: color 0.2s;
}

.close-button:hover {
  color: #1f2937;
}

.modal-form {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2937;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  margin-top: 20px;
}

.checkbox-input {
  width: 20px;
  height: 20px;
  border: 2px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  accent-color: #2563eb;
}

.checkbox-input:hover {
  border-color: #2563eb;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  user-select: none;
}

.crown-icon {
  font-size: 16px;
}

.modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 8px;
}

.cancel-button {
  padding: 10px 24px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.cancel-button:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.create-button {
  padding: 10px 24px;
  background: #2563eb;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: background 0.2s;
}

.create-button:hover {
  background: #1d4ed8;
}

.create-button:active {
  background: #1e40af;
}

@media (max-width: 480px) {
  .modal-content {
    width: 95%;
    max-width: none;
  }

  .modal-header {
    padding: 20px;
  }

  .modal-form {
    padding: 20px;
  }

  .modal-footer {
    flex-direction: column-reverse;
  }

  .cancel-button,
  .create-button {
    width: 100%;
  }
}
</style>
